package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesStationExtraDto(
    val ebikes: Int? = null,
)
